import React from 'react'
import loadable from '@loadable/component'

import ConvenienceMessage from '../../ConvenienceMessage/ConvenienceMessage'
import AvailabilityMessage from '../../AvailabilityMessage/AvailabilityMessage'

const CountDownTimer = loadable(() =>
  import(/* webpackChunkName: "count-down-timer" */ '../CountDownTimer/CountDownTimer')
)

export const formatAvailabilityMessage = (availabilityMessage, store) => {
  // Revisit this as there may be a better implementation
  if (!availabilityMessage) return ''
  return availabilityMessage.replace(store, `<strong>${store}</strong>`)
}

export const CollectionMessage = ({
  collectionIcon,
  collectionMessage,
  collectionStore,
  collectionCutoff,
  collectionStockCode,
  convenienceStore,
  isV2
}) => {
  const convenienceMessage = convenienceStore && convenienceStore.storeprepay && convenienceStore.storeprepay === 6
  const collectToday = collectionCutoff && collectionStockCode?.split('|')[0] === 'c2'

  const showCountDownTimer = collectToday && new Date().getDay() !== 0

  if (isV2) {
    return showCountDownTimer ? <CountDownTimer collectionCutoff={collectionCutoff} isV2={isV2} /> : null
  }

  return (
    <>
      <AvailabilityMessage
        icon={collectionIcon}
        message={formatAvailabilityMessage(collectionMessage, collectionStore)}
        store={collectionStore}
      />
      {convenienceMessage && <ConvenienceMessage />}
      {showCountDownTimer && <CountDownTimer collectionCutoff={collectionCutoff} />}
    </>
  )
}
